const cueSet1 = [
  {
          "duration": 0.0765305,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 0,
          "time": 0,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.153061,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 7680,
          "time": 0.306122,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000006,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 15360,
          "time": 0.612244,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.1530609999999999,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 23040,
          "time": 0.918366,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000006,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 30720,
          "time": 1.224488,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.1530609999999999,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 34560,
          "time": 1.3775490000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000006,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 38400,
          "time": 1.53061,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.1530610000000001,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 42240,
          "time": 1.683671,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000006,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 46080,
          "time": 1.836732,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.1530610000000001,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 53760,
          "time": 2.142854,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000006,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 61440,
          "time": 2.448976,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.15306099999999967,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 69120,
          "time": 2.7550980000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000006,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 76800,
          "time": 3.06122,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.15306099999999967,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 80640,
          "time": 3.214281,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000006,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 84480,
          "time": 3.367342,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.1530610000000001,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 92160,
          "time": 3.673464,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999961,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 99840,
          "time": 3.9795860000000003,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.15306099999999923,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 103680,
          "time": 4.132647,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 107520,
          "time": 4.285708,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.1530610000000001,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 115200,
          "time": 4.59183,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999961,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 122880,
          "time": 4.897952,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.1530610000000001,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 130560,
          "time": 5.204074,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999961,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 138240,
          "time": 5.5101960000000005,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999961,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 140160,
          "time": 5.5867265,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 142080,
          "time": 5.663257,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999961,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 144000,
          "time": 5.7397875,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 145920,
          "time": 5.816318,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 149760,
          "time": 5.969379,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999961,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 161280,
          "time": 6.428562,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999961,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 165120,
          "time": 6.5816230000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 168960,
          "time": 6.734684,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 176640,
          "time": 7.040806,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999961,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 184320,
          "time": 7.346928,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999961,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 188160,
          "time": 7.499989,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999961,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 192000,
          "time": 7.65305,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999961,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 195840,
          "time": 7.8061110000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999872,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 199680,
          "time": 7.959172000000001,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999872,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 207360,
          "time": 8.265294,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 211200,
          "time": 8.418355,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 215040,
          "time": 8.571416,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 222720,
          "time": 8.877538,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 224640,
          "time": 8.9540685,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 226560,
          "time": 9.030599,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999872,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 228480,
          "time": 9.107129500000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 230400,
          "time": 9.18366,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 238080,
          "time": 9.489782,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 245760,
          "time": 9.795904,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 253440,
          "time": 10.102026,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999872,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 261120,
          "time": 10.408148,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999872,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 268800,
          "time": 10.71427,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999872,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 276480,
          "time": 11.020392000000001,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 280320,
          "time": 11.173453,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 284160,
          "time": 11.326514,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 288000,
          "time": 11.479575,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 291840,
          "time": 11.632636,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 299520,
          "time": 11.938758,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 307200,
          "time": 12.24488,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 314880,
          "time": 12.551002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999872,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 322560,
          "time": 12.857124,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 326400,
          "time": 13.010185,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999872,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 330240,
          "time": 13.163246000000001,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 334080,
          "time": 13.316307,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 345600,
          "time": 13.77549,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 349440,
          "time": 13.928551,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 353280,
          "time": 14.081612,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 360960,
          "time": 14.387734,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 368640,
          "time": 14.693856,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 376320,
          "time": 14.999978,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999872,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 384000,
          "time": 15.3061,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 385920,
          "time": 15.3826305,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 387840,
          "time": 15.459161,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 389760,
          "time": 15.5356915,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999872,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 391680,
          "time": 15.612222000000001,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 395520,
          "time": 15.765283,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 407040,
          "time": 16.224466,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 410880,
          "time": 16.377527,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 414720,
          "time": 16.530588,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 422400,
          "time": 16.83671,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 430080,
          "time": 17.142832,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 433920,
          "time": 17.295893,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 437760,
          "time": 17.448954,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 441600,
          "time": 17.602015,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 445440,
          "time": 17.755076,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 453120,
          "time": 18.061198,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 456960,
          "time": 18.214259000000002,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 460800,
          "time": 18.36732,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 468480,
          "time": 18.673442,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 470400,
          "time": 18.749972500000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 472320,
          "time": 18.826503,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 474240,
          "time": 18.9030335,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 476160,
          "time": 18.979564,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 483840,
          "time": 19.285686000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 491520,
          "time": 19.591808,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.153061000000001,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 499200,
          "time": 19.89793,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 506880,
          "time": 20.204052,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.153061000000001,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 514560,
          "time": 20.510174,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 522240,
          "time": 20.816296,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.153061000000001,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 526080,
          "time": 20.969357,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 529920,
          "time": 21.122418,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.153061000000001,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 533760,
          "time": 21.275479,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 537600,
          "time": 21.42854,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.153061000000001,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 545280,
          "time": 21.734662,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 552960,
          "time": 22.040784000000002,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.153061000000001,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 560640,
          "time": 22.346906,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 568320,
          "time": 22.653028,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.153061000000001,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 572160,
          "time": 22.806089,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 576000,
          "time": 22.95915,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.153061000000001,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 583680,
          "time": 23.265272,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 591360,
          "time": 23.571394,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.153061000000001,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 595200,
          "time": 23.724455,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 599040,
          "time": 23.877516,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.15306099999999745,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 606720,
          "time": 24.183638000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 614400,
          "time": 24.48976,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.153061000000001,
          "durationTicks": 3840,
          "midi": 38,
          "name": "D2",
          "ticks": 622080,
          "time": 24.795882,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 629760,
          "time": 25.102004,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 631680,
          "time": 25.1785345,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 633600,
          "time": 25.255065000000002,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 635520,
          "time": 25.3315955,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 637440,
          "time": 25.408126,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 641280,
          "time": 25.561187,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 652800,
          "time": 26.02037,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 656640,
          "time": 26.173431,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 660480,
          "time": 26.326492000000002,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 668160,
          "time": 26.632614,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 675840,
          "time": 26.938736,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 679680,
          "time": 27.091797,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 683520,
          "time": 27.244858,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 687360,
          "time": 27.397919,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 691200,
          "time": 27.55098,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 698880,
          "time": 27.857102,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 702720,
          "time": 28.010163000000002,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 704640,
          "time": 28.0866935,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 706560,
          "time": 28.163224,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 708480,
          "time": 28.2397545,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 710400,
          "time": 28.316285,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 712320,
          "time": 28.3928155,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 714240,
          "time": 28.469346,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 718080,
          "time": 28.622407,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 721920,
          "time": 28.775468,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 723840,
          "time": 28.8519985,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 733440,
          "time": 29.234651,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 735360,
          "time": 29.3111815,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 737280,
          "time": 29.387712,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 744960,
          "time": 29.693834,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 752640,
          "time": 29.999956,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 760320,
          "time": 30.306078,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 768000,
          "time": 30.6122,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 771840,
          "time": 30.765261,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 775680,
          "time": 30.918322,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 779520,
          "time": 31.071383,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 783360,
          "time": 31.224444000000002,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.0765305000000005,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 791040,
          "time": 31.530566,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 798720,
          "time": 31.836688000000002,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 806400,
          "time": 32.14281,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 814080,
          "time": 32.448932,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 817920,
          "time": 32.601993,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 821760,
          "time": 32.755054,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 825600,
          "time": 32.908115,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 837120,
          "time": 33.367298,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 840960,
          "time": 33.520359,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 844800,
          "time": 33.67342,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 852480,
          "time": 33.979542,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 860160,
          "time": 34.285664,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 867840,
          "time": 34.591786,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 875520,
          "time": 34.897908,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 877440,
          "time": 34.9744385,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 879360,
          "time": 35.050969,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 881280,
          "time": 35.1274995,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 883200,
          "time": 35.20403,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 887040,
          "time": 35.357091000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 898560,
          "time": 35.816274,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 902400,
          "time": 35.969335,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 906240,
          "time": 36.122396,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 913920,
          "time": 36.428518000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 921600,
          "time": 36.73464,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 925440,
          "time": 36.887701,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 929280,
          "time": 37.040762,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 933120,
          "time": 37.193823,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 936960,
          "time": 37.346884,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 944640,
          "time": 37.653006,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 948480,
          "time": 37.806067,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 950400,
          "time": 37.8825975,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 952320,
          "time": 37.959128,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 954240,
          "time": 38.035658500000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 956160,
          "time": 38.112189,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 958080,
          "time": 38.1887195,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 960000,
          "time": 38.26525,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 961920,
          "time": 38.3417805,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 967680,
          "time": 38.571372000000004,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 975360,
          "time": 38.877494,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 979200,
          "time": 39.030555,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 981120,
          "time": 39.107085500000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 983040,
          "time": 39.183616,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 990720,
          "time": 39.489738,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 998400,
          "time": 39.79586,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1006080,
          "time": 40.101982,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1013760,
          "time": 40.408104,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1017600,
          "time": 40.561165,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1021440,
          "time": 40.714226000000004,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1025280,
          "time": 40.867287,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 1029120,
          "time": 41.020348,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1031040,
          "time": 41.0968785,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1044480,
          "time": 41.632592,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1052160,
          "time": 41.938714,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 1059840,
          "time": 42.244836,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1063680,
          "time": 42.397897,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1067520,
          "time": 42.550958,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1071360,
          "time": 42.704019,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1082880,
          "time": 43.163202,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1086720,
          "time": 43.316263,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 1090560,
          "time": 43.469324,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1094400,
          "time": 43.622385,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1105920,
          "time": 44.081568000000004,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1109760,
          "time": 44.234629,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 1121280,
          "time": 44.693812,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1123200,
          "time": 44.7703425,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1125120,
          "time": 44.846873,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1127040,
          "time": 44.9234035,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1128960,
          "time": 44.999934,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1132800,
          "time": 45.152995000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1144320,
          "time": 45.612178,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1148160,
          "time": 45.765239,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 1152000,
          "time": 45.9183,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1155840,
          "time": 46.071361,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1167360,
          "time": 46.530544,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1171200,
          "time": 46.683605,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1175040,
          "time": 46.836666,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1178880,
          "time": 46.989727,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 1182720,
          "time": 47.142788,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1186560,
          "time": 47.295849000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1194240,
          "time": 47.601971,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1196160,
          "time": 47.6785015,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 1205760,
          "time": 48.061154,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1207680,
          "time": 48.1376845,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 1209600,
          "time": 48.214215,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1211520,
          "time": 48.2907455,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 1213440,
          "time": 48.367276000000004,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1217280,
          "time": 48.520337,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1228800,
          "time": 48.97952,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1236480,
          "time": 49.285642,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 1244160,
          "time": 49.591764,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1251840,
          "time": 49.897886,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1259520,
          "time": 50.204008,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1263360,
          "time": 50.357069,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1267200,
          "time": 50.510130000000004,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1271040,
          "time": 50.663191,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 1274880,
          "time": 50.816252,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1282560,
          "time": 51.122374,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1290240,
          "time": 51.428496,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1297920,
          "time": 51.734618,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 1305600,
          "time": 52.04074,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1309440,
          "time": 52.193801,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1313280,
          "time": 52.346862,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1317120,
          "time": 52.499923,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1320960,
          "time": 52.652984000000004,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1322880,
          "time": 52.7295145,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 1324800,
          "time": 52.806045,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1328640,
          "time": 52.959106,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1332480,
          "time": 53.112167,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1334400,
          "time": 53.1886975,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 1336320,
          "time": 53.265228,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1338240,
          "time": 53.3417585,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1351680,
          "time": 53.877472,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1359360,
          "time": 54.183594,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 1367040,
          "time": 54.489716,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1368960,
          "time": 54.5662465,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1370880,
          "time": 54.642777,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1372800,
          "time": 54.7193075,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1374720,
          "time": 54.795838,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1376640,
          "time": 54.8723685,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1390080,
          "time": 55.408082,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1393920,
          "time": 55.561143,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 1397760,
          "time": 55.714204,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1399680,
          "time": 55.7907345,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.03993935468749754,
          "durationTicks": 1002,
          "midi": 36,
          "name": "C2",
          "ticks": 1401600,
          "time": 55.867265,
          "velocity": 0.23622047244094488
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1402603,
          "time": 55.907244214322915,
          "velocity": 0.23622047244094488
        },
        {
          "duration": 0.03826525000000203,
          "durationTicks": 960,
          "midi": 38,
          "name": "D2",
          "ticks": 1404480,
          "time": 55.98206075,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1405440,
          "time": 56.020326000000004,
          "velocity": 0.23622047244094488
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1409280,
          "time": 56.173387,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1413120,
          "time": 56.326448,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1416960,
          "time": 56.479509,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1420800,
          "time": 56.63257,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1424640,
          "time": 56.785631,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 1428480,
          "time": 56.938692,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1430400,
          "time": 57.0152225,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1432320,
          "time": 57.091753000000004,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1436160,
          "time": 57.244814,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 36,
          "name": "C2",
          "ticks": 1440000,
          "time": 57.397875,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1441920,
          "time": 57.4744055,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 1451520,
          "time": 57.857058,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1453440,
          "time": 57.9335885,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 1455360,
          "time": 58.010119,
          "velocity": 0.6299212598425197
        },
        {
          "duration": 0.07653050000000405,
          "durationTicks": 1920,
          "midi": 38,
          "name": "D2",
          "ticks": 1457280,
          "time": 58.0866495,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.07653049999999695,
          "durationTicks": 1920,
          "midi": 37,
          "name": "C#2",
          "ticks": 1459200,
          "time": 58.163180000000004,
          "velocity": 0.6299212598425197
        }
];

export default cueSet1;
